// Correspondência avançada manual do Meta Pixel.
// Os dados do formulário são normalizados como a Meta pede e criptografados (SHA-256)
// no próprio navegador; só os hashes são guardados e enviados.

export const PIXEL_ID = '1176140955216307';

const semAcento = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '');

async function sha256(texto) {
  const bytes = new TextEncoder().encode(texto);
  const hash = await window.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

// Recebe o objeto do formulário (nome, email, celular, cep, cidade, estado)
// e devolve { em, ph, fn, ln, ct, st, zp, country } já em hash. Campos vazios ficam de fora.
export async function hashUserData(form) {
  if (!window.crypto || !window.crypto.subtle) return null;

  const partesNome = String(form.nome || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  const celular = String(form.celular || '').replace(/\D/g, '');

  const campos = {
    em: String(form.email || '').trim().toLowerCase(),
    ph: celular ? '55' + celular : '',
    fn: partesNome.length ? partesNome[0] : '',
    ln: partesNome.length > 1 ? partesNome[partesNome.length - 1] : '',
    ct: semAcento(String(form.cidade || '').toLowerCase()).replace(/[^a-z]/g, ''),
    st: String(form.estado || '').trim().toLowerCase(),
    zp: String(form.cep || '').replace(/\D/g, ''),
    country: 'br',
  };

  const resultado = {};
  for (const [chave, valor] of Object.entries(campos)) {
    if (valor) resultado[chave] = await sha256(valor);
  }
  return resultado;
}

// Reinicializa o Pixel com os dados do cliente para os próximos eventos.
export function setUserData(userData) {
  if (window.fbq && userData && Object.keys(userData).length) {
    window.fbq('init', PIXEL_ID, userData);
  }
}
